module.exports = __webpack_public_path__ + "static/media/lubricants-icon.39beafbb.png";